import { render, staticRenderFns } from "./LogoLeftBottom.vue?vue&type=template&id=78002eb2"
import script from "./LogoLeftBottom.vue?vue&type=script&lang=js"
export * from "./LogoLeftBottom.vue?vue&type=script&lang=js"
import style0 from "./LogoLeftBottom.vue?vue&type=style&index=0&id=78002eb2&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78002eb2')) {
      api.createRecord('78002eb2', component.options)
    } else {
      api.reload('78002eb2', component.options)
    }
    module.hot.accept("./LogoLeftBottom.vue?vue&type=template&id=78002eb2", function () {
      api.rerender('78002eb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Shared/LogoLeftBottom.vue"
export default component.exports